import React from 'react';
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';
import * as Yup from 'yup';

import FormInput from '../../../components/form/FormInput';

import {
  audioPromptsAdd,
  audioPromptsUpdate
} from '../../../store/slices/tenantSlices/incomingSlice';

const AddEditPromptModal = ({ isOpen, onCloseClick, isEdit = false, editRecord = null }) => {
  const dispatch = useDispatch();

  const initialValues = {
    name: '',
    file: ''
  };

  const validationSchema = Yup.object({
    name: Yup.string().required('name is required'),
    file: Yup.string().required('file is required')
  });

  const onSubmit = async () => {
    const formData = new FormData();
    formData.append('name', values.name);
    if (values.file) {
      formData.append('file', values.file);
    }

    if (isEdit) {
      try {
        formData.append('id', editRecord.id);
        const response = await dispatch(audioPromptsUpdate(formData)).unwrap();

        if (response && response?.message) {
          toast.success('Record Updated Successfully');
          onCloseClick(true);
          resetForm();
        } else {
          toast.error(response.error);
        }
      } catch (error) {
        console.log('error', error);
      }
    } else {
      try {
        const response = await dispatch(audioPromptsAdd(formData)).unwrap();

        if (response && response?.message) {
          toast.success('Record Added Successfully');
          onCloseClick(true);
          resetForm();
        } else {
          toast.error(response.error);
        }
      } catch (error) {
        console.log('error', error);
      }
    }
  };

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    resetForm,
    setFieldValue
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  return (
    <Modal isOpen={isOpen} size="xl" centered>
      <ModalHeader className="justify-content-center py-2">
        <div className="fs-5">{isEdit ? 'Edit Audio Prompts' : 'Add Audio Prompts'}</div>
      </ModalHeader>
      <ModalBody className="px-4">
        <form id="audio-prompts" onSubmit={handleSubmit}>
          <Row>
            <Col lg="4" md="4">
              <FormInput
                name="name"
                label="Name"
                placeholder="Enter Name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
            <Col lg="4" md="4">
              <FormGroup>
                <Label htmlFor="prompt-file-upload">File</Label>
                <div
                  className="file-upload-container cursor-pointer"
                  // onClick={() => document.getElementById('prompt-file-upload').click()}
                >
                  <Input
                    type="text"
                    className="file-name cursor-pointer"
                    placeholder={
                      values.file && values.file.name ? values.file.name : 'Choose a file'
                    }
                    readOnly
                  />
                  <label className="upload-button cursor-pointer">
                    <Icon.Upload size={18} className="cursor-pointer" />
                    <Input
                      type="file"
                      id="prompt-file-upload"
                      className="file-upload cursor-pointer"
                      accept="audio/wav"
                      onChange={(e) => setFieldValue('file', e.target.files[0])}
                    />
                  </label>
                </div>
              </FormGroup>
            </Col>
          </Row>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            onCloseClick();
            resetForm();
          }}
          className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button form="audio-prompts" type="submit" className="px-5 bg-primary border-primary">
          {isEdit ? 'Update' : 'Save'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AddEditPromptModal.propTypes = {
  isOpen: PropTypes.bool,
  isEdit: PropTypes.bool,
  onCloseClick: PropTypes.func,
  editRecord: PropTypes.any
};

export default AddEditPromptModal;
